<template>
  <img
    v-if="props.src"
    :src="props.src"
    alt=""
    :class="ns.b()"
    :style="style"
    v-bind="$attrs"
  />
  <i v-else :class="ns.b()" :style="style" v-bind="$attrs">
    <slot />
  </i>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { addUnit, isUndefined } from '@park-ui/utils'
import { useAttrs, useNamespace } from '@park-ui/hooks'
import { iconProps } from './icon'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'ElIcon',
  inheritAttrs: false,
})

const props = defineProps(iconProps)
const attrs: any = useAttrs()
const ns = useNamespace('icon')

const style = computed<CSSProperties>(() => {
  if (!props.size && !props.color) return {}

  return {
    fontSize: isUndefined(props.size) ? undefined : addUnit(props.size),
    '--color': props.color,
    filter: props.src
      ? `drop-shadow(0 0 0 ${
          props.color || (attrs.style && attrs.style.color)
        })`
      : undefined,
  }
})
</script>
